import {
  Validator
} from 'vee-validate'

import store from '../store/state'
import {constants} from '@/utils/Constants.js'

Validator.extend('bonus', {
  getMessage: () => 'Rebate can range anywhere between 0% and 100%',
  validate: (value) => value >= 0 && value <= 100
})

const activeAccount = store.authentication.activeAccount

Validator.extend('account_verified', {
  getMessage: () => {
    return ''
  },
  validate (value) {
    // account is not verified && (current amount + total fund) > limit && not the first fund
    const hasToBeVerified = activeAccount.verification_status !== constants.ACCOUNT_VERIFICATION_STATUS.VERIFIED &&
      parseFloat(value) + parseFloat(activeAccount.total_fund) > constants.NOT_VERIFIED_FUND_ACCOUNT_LIMIT &&
      activeAccount.total_fund > 0

    return !hasToBeVerified
  }
})

Validator.extend('first_payment', {
  getMessage: () => {
    return ''
  },
  validate (value) {
    // account is not verified && current amount > limit && is the first fund
    const isFirstPayment = activeAccount.verification_status !== constants.ACCOUNT_VERIFICATION_STATUS.VERIFIED &&
      value > constants.NOT_VERIFIED_FUND_ACCOUNT_LIMIT &&
      activeAccount.total_fund === 0

    return !isFirstPayment
  }
})
